module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-4-5b053943185de71856a7d02375584deb.jpg";